import {ApiService} from "../api";
import {Education, EducationSendDTO} from "../../types";
import {AxiosResponse} from "axios";
import {Log} from "../../utils/Log";

export class EducationAPI extends ApiService {
    private constructor() {
        super();
    }

    async getEducation(): Promise<Education[]> {
        const response: AxiosResponse<Education[]> = await this.api.get('/education');
        return response.data;
    }

    async createEducation(data: EducationSendDTO): Promise<Education | undefined> {
        Log.writeLogDebug(data);
        try {
            const response: AxiosResponse<Education> = await this.api.post('/education', data);
            return response.data;
        }
        catch (e) {
            Log.writeLogDebug(e);
        }
        return undefined;
    }

    async updateEducation(id: string, data: Partial<EducationSendDTO>): Promise<Education> {
        const response: AxiosResponse<Education> = await this.api.put(`/education/${id}`, data);
        return response.data;
    }

    async deleteEducation(id: string): Promise<void> {
        await this.api.delete(`/education/${id}`);
    }

    async sendInstitutionEmail(educationId: string): Promise<void> {
        await this.api.post(`/education/${educationId}/send-institution-email`);
    }
}